module.exports = __webpack_public_path__ + "img/image_body-point_02_01.133ec1f3.svg";